import Forbidden from '../../../base/pages/errorPages/Forbidden';

const forbidden: Forbidden = {
  title: 'Neautorizovaný přístup',
  subtitle: 'K zobrazení této stránky nemáte oprávnění.',
  quip: 'Být Vámi, tak bych odešel, Radek už čeká za dveřmi!'
};

export default forbidden;
